"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AlarmToAsset = function AlarmToAsset(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "18",
    viewBox: "0 0 60 18",
    width: "60",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m47.39 1.3v4.09h-4.09v-4.09zm1.31-1.3h-6.7v6.7h6.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m58.7 1.3v4.09h-4.09v-4.09zm1.3-1.3h-6.7v6.7h6.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m47.42 12.61v4.09h-4.08v-4.09zm1.28-1.31h-6.7v6.7h6.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m50.22 0h1.56v6.7h-1.56z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m47.71 9.01h12.29v1.51h-12.29z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m42 7.5h3.17v1.51h-3.17z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m50.61 12.76h4.91v1.51h-4.91z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m58.43 12.76v3.67h-5.16v1.57h6.73v-.01-1.56-3.67z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.39 15.78a1.16 1.16 0 0 1 -1.15-1.15v-3.38a5.22 5.22 0 0 0 -3-4.74 2.24 2.24 0 0 0 -4.46 0 5.22 5.22 0 0 0 -3 4.74v3.38a1.16 1.16 0 0 1 -1.15 1.15.36.36 0 0 0 0 .72h4.54a1.87 1.87 0 0 0 3.66 0h4.56a.36.36 0 0 0 0-.72z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2.61 7.11a.36.36 0 0 1 -.36-.36 4.51 4.51 0 0 1 4.5-4.5.36.36 0 0 1 .36.36.36.36 0 0 1 -.36.39 3.79 3.79 0 0 0 -3.75 3.75.36.36 0 0 1 -.39.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m.36 7.11a.36.36 0 0 1 -.36-.36 6.76 6.76 0 0 1 6.75-6.75.36.36 0 0 1 0 .72 6 6 0 0 0 -6 6 .36.36 0 0 1 -.39.39z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.39 7.11a.36.36 0 0 1 -.39-.36 3.79 3.79 0 0 0 -3.75-3.75.36.36 0 0 1 -.36-.36.37.37 0 0 1 .36-.36 4.51 4.51 0 0 1 4.5 4.5.36.36 0 0 1 -.36.33z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m17.64 7.11a.36.36 0 0 1 -.36-.36 6 6 0 0 0 -6-6 .36.36 0 0 1 -.36-.36.36.36 0 0 1 .33-.39 6.76 6.76 0 0 1 6.75 6.75.36.36 0 0 1 -.36.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.56 8.74h10.71l-1.65-1.64a.91.91 0 0 1 1.28-1.28l3.18 3.18a.9.9 0 0 1 0 1.27l-3.18 3.19a.91.91 0 0 1 -1.28 0 .9.9 0 0 1 0-1.27l1.65-1.65h-10.71a.9.9 0 0 1 0-1.8z"
  })));
};

var _default = AlarmToAsset;
exports["default"] = _default;